export function none(...array: (boolean | null | undefined)[]): boolean {
  return array.every((el) => !el);
}
